import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async criaItem(itemValores = {}){

        let pedidoDeCompraItem;

        try{

            itemValores = {
                ...itemValores,
                status: "Em Desenvolvimento",
                dataCriacao: UtilDateTime.todayUTC(),
            }

            pedidoDeCompraItem = await ERP.postOne(Schema.PEDIDO_DE_COMPRA_ITENS, itemValores);
            if(pedidoDeCompraItem.status != 200){
                throw pedidoDeCompraItem;
            }

            console.log(pedidoDeCompraItem);

        }catch(e){

            console.log(e);
            return pedidoDeCompraItem;

        }

        return pedidoDeCompraItem;

    },

    async criaItens(itemValores = []){

        let pedidoDeCompraItens;

        try{

            itemValores = itemValores.map((itemValor)=>{

                return{
                    ...itemValor,
                    status: "Em Desenvolvimento",
                    dataCriacao: UtilDateTime.todayUTC(),
                }


            });

            pedidoDeCompraItens = await ERP.postMany(Schema.PEDIDO_DE_COMPRA_ITENS, itemValores);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            console.log(pedidoDeCompraItens);

        }catch(e){

            console.log(e);
            return pedidoDeCompraItens;

        }

        return pedidoDeCompraItens;

    },

    async alteraItem(itemValores = {}){

        let pedidoDeCompraItem;

        try{

            pedidoDeCompraItem = await ERP.patchOne(Schema.PEDIDO_DE_COMPRA_ITENS, itemValores);
            if(pedidoDeCompraItem.status != 200){
                throw pedidoDeCompraItem;
            }

            console.log(pedidoDeCompraItem);

        }catch(e){

            console.log(e);
            return pedidoDeCompraItem;

        }

        return pedidoDeCompraItem;

    },

    async alteraItens(itensValores = []){

        let pedidoDeCompraItens;

        try{

            pedidoDeCompraItens = await ERP.patchMany(Schema.PEDIDO_DE_COMPRA_ITENS, itensValores);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            console.log(pedidoDeCompraItens);

        }catch(e){

            console.log(e);
            return pedidoDeCompraItens;

        }

        return pedidoDeCompraItens;

    },

}